/** GRF-27: the full address of an item's page, as it is opened in the browser (`https://<host>/items/EVP-884`). */
export function itemUrl(key: string, origin: string = window.location.origin): string {
  return `${origin}/items/${encodeURIComponent(key)}`;
}
